import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import queryString from 'query-string'
import Button from '../UniformComponents/Button'
import LinkButton from '../UniformComponents/LinkButton'
import Anchor from '../UniformComponents/Anchor'
import PasswordInput from './components/PasswordInput'
import Input from '../components/form/Input'
import LoginLayout from '../components/Layouts/Login'

import './login.scss'

@observer
class Login extends Component {
    constructor(props) {
        super(props)
        props.store.invalidateSession()
        document.title = 'explori.com - login'
        this.fields = {}
        this.state = {
            error: undefined,
        }
        this.query = new URLSearchParams(location.search)
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            location.reload()
        }, (1200 * 1000)) // 20 mins
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    register = (name, validate) => {
        this.fields[name] = validate
    }

    unregister = (name) => {
        Reflect.deleteProperty(this.fields, name)
    }

    renderErrorsNew = () => {
        const { error } = this.state
        return !error
            ? null
            : (
                <div className="error-msg">
                    <div className="heading">
                        <i className="fa-regular fa-ban" />
                        <p className="msg-type">{i18n.t('reset_password_msg_error')}</p>
                    </div>
                    <p className="desc">{error}</p>
                </div>
            )
    }

    renderErrorsOld = () => {
        let errors = []
        try {
            errors = cfLoginErrors()
        } catch (e) { console.log(e) }

        return errors.length === 0
            ? null
            : (
                <div className="error-msg">
                    <div className="heading">
                        <i className="fa-regular fa-ban" />
                        <p className="msg-type">{i18n.t('reset_password_msg_error')}</p>
                    </div>
                    <p className="desc">{errors[0]}</p>
                </div>
            )
    }

    renderErrors = () => (
        process.env.USE_NEW_LOGIN
            ? this.renderErrorsNew()
            : this.renderErrorsOld()
    )

    getLoginUrl = (loginUrl) => {
        if (this.query.has('pagePath')) {
            loginUrl += `?pagePath=${this.query.get('pagePath')}`
        }
        return loginUrl
    }

    loginNew = async (e) => {
        const { store } = this.props
        const { csrf } = store

        e.preventDefault()

        const loginUrl = this.getLoginUrl('/api/login')
        const request = await fetch(loginUrl, {
            method: 'post',
            withCredentials: true,
            credentials: 'include',
            headers: new Headers({
                'Content-Type': 'application/json; charset=UTF-8',
            }),
            body: JSON.stringify({
                email: e.target.elements.email.value,
                password: e.target.elements.password.value,
                csrf,
            }),
        })

        const response = await request.json()

        console.log(request.status, response)

        if (request.status === 200) { // ok
            document.location = response.redirect
        } else if (request.status === 403) { // auth error
            this.setState({
                error: response.message,
            })
        } else { // error response
            this.setState({
                error: 'Error during login',
            })
        }
    }

    showSSO = () => {
        const { host, search } = location
        const params = queryString.parse(search)

        return host !== 'admin.explori.com' || params.useSSO === '1'
    }

    isValid = (e) => {
        const fieldNames = ['email', 'password']
        return fieldNames.map((fieldName) => (
            this.fields[fieldName]({
                value: e.target[fieldName].value,
                name: fieldName,
            }, true)
        )).every((valid) => valid)
    }

    login = async (e) => {
        if (process.env.USE_NEW_LOGIN) {
            this.loginNew(e)
        }
    }

    render() {
        const { store } = this.props
        const { csrf } = store
        const loginUrl = this.getLoginUrl('/login')

        return (
            <LoginLayout>
                <div className="login-wrapper">
                    <div className="logo">
                        <img src={`${process.env.CDN_URL}/images/logo_explori.png`} alt="Explori logo" />
                    </div>
                    <h3 style={{ color: "white" }}>{i18n.t('login_getStarted', 'Let\'s get started')}</h3>
                    <form action="/login" method="post" autoComplete onSubmit={this.login}>
                        <Input
                            cssClass="login-input light email-input"
                            label={i18n.t('email', 'Email')}
                            name="email"
                            id="email"
                            placeholder="Enter your email address"
                            register={this.register}
                            unregister={this.unregister}
                            emptyError={i18n.t('error_email')}
                            isMandatory
                            formatError={i18n.t('format_error_email')}
                            format={(value) => (
                                value.match(/.*@.*\..*/gi)
                            )}
                        />
                        <PasswordInput
                            cssClass="login-input light pwd-input"
                            label={i18n.t('password', 'Password')}
                            name="password"
                            id="password"
                            placeholder="Enter your password"
                            register={this.register}
                            unregister={this.unregister}
                            emptyError={i18n.t('error_password')}
                            isMandatory
                        />
                        <input type="text" name="csrf" id="csrf" hidden value={csrf} />
                        {this.renderErrors()}
                        <Button
                            cssClass="login-btn primary large"
                            label={i18n.t('login', 'Login')}
                            type="submit"
                        />
                    </form>
                    <Anchor cssClass="external-anchor" href="/passwordreset">
                        {i18n.t('forgot_pwd', 'Forgot password')}
                        <i className="fa-sharp fa-regular fa-arrow-right" />
                    </Anchor>
                    {this.showSSO() && (
                        <Fragment>
                            <div className="divider">
                                <hr className="line" />
                                <p className="divider-text">or</p>
                                <hr className="line" />
                            </div>
                            <LinkButton
                                cssClass="msft-btn secondary large"
                                href="/api/login/azure"
                                isExternal
                            >
                                <img
                                    alt="microsoft-logo"
                                    style={{ marginRight: '12px', height: '19px' }}
                                    src="https://learn.microsoft.com/en-us/azure/active-directory/develop/media/howto-add-branding-in-azure-ad-apps/ms-symbollockup_mssymbol_19.png"
                                />
                                {i18n.t('microsft_login', 'Continue with Microsoft')}
                            </LinkButton>
                        </Fragment>
                    )}
                </div>
            </LoginLayout>
        )
    }
}

export default Login
